import Table from "../../../components/Table/Table"
import { useState, useEffect, useMemo } from "react"
import axios from "axios"
import { Box, Button, Fade, LinearProgress, Tooltip, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Filter from "../../../components/Filter/Filter"
import { useSelector } from "react-redux"
import { getFilterValues } from "../../../utils/getFilterValues"
import { logOut } from "../../../utils/logOut"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { CallFilterData, ConversationFilterData } from "../../../components/Filter/FilterData"
import { onChangeConversationFilter } from "../../../store/filter/filterReducer"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import AddchartIcon from '@mui/icons-material/Addchart';

export default function Сonversations() {
    //Declaring states
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)

    const { showSnackbar } = useSnackbar();


    //Set header title
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setCurrentPage('Сonversations'))
    }, [dispatch]);

    const filters = useSelector((state: any) => state.filter.filterUserData.conversation)

    // Making a request to get data for a table or download a file
    async function fetchData(params: any = {}) {
        setLoading(true)

        let downloadFile: boolean = Boolean((params['downloadcsv'] && params['downloadcsv'] != '0') || (params['downloadmp3'] && params['downloadmp3'] != '0'))

        if (!downloadFile) {
            params = { ...params, calculatetotalcount: true }
        }
        try {
            const response = await axios.get('https://cardgarantsales.com/restapi/conversation', {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow, maxRows },
                responseType: downloadFile ? 'blob' : 'json'
            })

            if (downloadFile) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report.zip');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount);
                    setTableData(response.data.slice(1));
                    console.log(response.data.slice(1));

                } else {
                    showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error');
                }
            }
            setLoading(false);
            if (downloadFile) {
                dispatch(onChangeConversationFilter({ type: 'downloadcsv', value: '0' }))
                dispatch(onChangeConversationFilter({ type: 'downloadmp3', value: '0' }))
                let updatedFilters = filters.map((el: any) => {
                    if (el.name == 'Download CSV') {
                        return {
                            ...el, params: [{
                                "type": "downloadcsv",
                                "label": "Download CSV",
                                "value": "0",
                                "input": "checkbox"
                            }]
                        }
                    }
                    else if (el.name == 'Download Mp3') {
                        return {
                            ...el, params: [{
                                "type": "downloadmp3",
                                "label": "Download Mp3",
                                "value": "0",
                                "input": "checkbox"
                            }]
                        }
                    }
                    else return el
                });

                localStorage.setItem(`conversation_filter`, JSON.stringify(updatedFilters));
            }




        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch);
            } else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false);
        }
    }

    //Making a request to get data for a table
    // async function fetchData(params: object = {}) {
    //     setLoading(true)
    //     try {
    //         const response = await axios.get('https://cardgarantsales.com/restapi/conversation', {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 "Authorization": "Bearer " + localStorage.getItem('access_token')
    //             },
    //             params: { ...params, startRow, maxRows, calculatetotalcount: true }
    //         })
    //         if (response.data !== null) {
    //             if (typeof (response.data) === 'object') {
    //                 setTotalRows(+response.data[0].totalcount)
    //                 setTableData(response.data.slice(1))
    //             }
    //             else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
    //         }
    //         setLoading(false)
    //     } catch (error: any) {
    //         console.log(error);
    //         if (error.code === "ERR_BAD_REQUEST") {
    //             logOut(dispatch)
    //         }
    //         else if (error.code === "ERR_NETWORK") {
    //             showSnackbar('ERROR NETWORK', 'error')
    //         }
    //         setLoading(false)
    //     }
    // }


    //on load page send request to get table data with filters
    useEffect(() => {
        fetchData(getFilterValues(filters))
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filters])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    function handleRememberConversations() {
        if (tableData.length > 100) {
            showSnackbar(<TranslatedText text={'You can select up to 100 conversations at a time'} />, 'error')
            return
        }
        let conversationIds = tableData.map((el: any) => el.uniqueid)
        localStorage.setItem('remembered_conversations', JSON.stringify(conversationIds))
        showSnackbar(<><TranslatedText text={'Selected for conversation analytics'} />: {conversationIds.length}</>, 'success')
        
    }

    const memoizedTable = useMemo(() => <SimplifiedTable rows={typeof (tableData) === 'object' ? tableData : []} page={'conversation'} />, [tableData]);


    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column' }}>
            <Filter exclude={accesslevel !== "5" ? ['partnerbank'] : []} fetchData={(params: object) => fetchData(params)} page="conversation" filtersList={ConversationFilterData} />
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {memoizedTable}
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto', zIndex: 1000, }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                            <Tooltip title={<TranslatedText text={"Remember all conversations on the page for conversation analysis (maximum 100)"} />} placement="top">
                                <Button color="success" onClick={() => handleRememberConversations()} size="small" sx={{ ml: 2, mt: 2, display: 'flex', alignItems: 'center' }} endIcon={<AddchartIcon />} variant="outlined" >{<TranslatedText text={"Remember for conversation analytics"} />}</Button>
                            </Tooltip>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}